import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ReportExportTask,
  type ReportExportTaskConstructor,
} from './ReportExportTask'
import { ExportTaskStatuses } from '../enums/ExportTaskStatusEnum'

export const ReportExportTaskConstructorFactory =
  Factory.Sync.makeFactory<ReportExportTaskConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    status: ExportTaskStatuses.PREPARING,
    filters: Factory.each(() => [
      {
        label: 'Purchased Date From',
        value: '2024-01-01',
        type: 'date' as const,
      },
    ]),
    file: null,
    index: 0,
    max: Factory.each(() => faker.random.number({ min: 1, max: 100 })),
    createdAt: '2024-01-15T10:00:00Z',
    requestedDate: null,
    isActive: true,
  })

export const ReportExportTaskFactory = EntityFactory(
  ReportExportTask,
  ReportExportTaskConstructorFactory
)
